import { defineComponent as _defineComponent } from 'vue'

import { SIGNAL_CATEGORIES_INFO, ISignal, SIGNALS_INFO } from "@/shared";
import AccountAddress from "@/components/common/AccountAddress.vue";
import TableResponsive from "@/components/common/TableResponsive.vue";
import TokenLoad from "@/components/token/TokenLoad.vue";
import Spinner from "@/components/common/Spinner.vue";

// props
interface IProps {
	signals: ISignal[];
}
interface IEmits {
	(e: "show", signal: ISignal): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SignalList',
  props: {
    signals: null
  },
  emits: ["show"],
  setup(__props: any, { emit }: { emit: ({
	(e: "show", signal: ISignal): void;
}), expose: any, slots: any, attrs: any }) {



// methods
function showSignal(signal: ISignal) {
	emit("show", signal);
}

// emit


return { __sfc: true,showSignal, emit, SIGNAL_CATEGORIES_INFO, SIGNALS_INFO, AccountAddress, TableResponsive, TokenLoad, Spinner }
}

})